export default __webpack_public_path__ + "static/media/07_AnimateBy4Corners.d1636d21.mp4";